import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Clock, MapPin, ArrowUpRight } from "lucide-react";
import { CORSI, courseUrl } from "../mock";
import Reveal from "./ui/Reveal";

export default function CorsiSingoli() {
  const [active, setActive] = useState(0);
  const c = CORSI[active];

  return (
    <section id="corsi" className="py-24 lg:py-36">
      <div className="container-max">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
          <div>
            <span className="section-label">Programmi completi</span>
            <Reveal variant="zoom" as="h2" className="font-display text-4xl lg:text-6xl leading-[1] text-white mt-6 max-w-3xl">
              Scegli il tuo percorso.<br />
              <span className="italic font-light text-white/60">Singolo o completo.</span>
            </Reveal>
          </div>
          <p className="text-white/60 max-w-md text-base">
            Partecipa all’esperienza completa o scegli il singolo corso che fa per te.
            Ogni modulo è pensato per essere autonomo, pratico e applicabile da subito.
          </p>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap gap-2 mb-8 border-b border-white/5 pb-2 overflow-x-auto">
          {CORSI.map((corso, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              className={`flex-shrink-0 px-4 py-3 rounded-lg text-xs lg:text-sm transition-all border ${
                active === i
                  ? "bg-white text-black border-white"
                  : "bg-transparent text-white/60 border-white/10 hover:text-white hover:border-white/30"
              }`}
            >
              <span className="font-mono-label">{corso.n}</span>
              <span className="ml-2 hidden sm:inline">{corso.title.split("\u2013")[0].trim().substring(0, 30)}</span>
            </button>
          ))}
        </div>

        {/* Active course */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5 bg-card border border-white/10 rounded-2xl p-8 lg:p-10">
            <div className="font-mono-label text-white/40 text-xs">Modulo {c.n} / 05</div>
            <h3 className="font-display text-3xl lg:text-4xl text-white mt-4 leading-tight">{c.title}</h3>
            <p className="text-white/60 mt-3">{c.subtitle}</p>

            <div className="mt-8 space-y-3">
              <div className="flex items-center gap-3 text-white/80 text-sm">
                <Clock size={16} className="text-lime" /> {c.hours}
              </div>
              <div className="flex items-center gap-3 text-white/80 text-sm">
                <MapPin size={16} className="text-lime" /> Montacchiello Campus, Pisa
              </div>
            </div>

            <div className="mt-8">
              <div className="font-mono-label text-white/40 text-[11px] mb-3">Obiettivo</div>
              <p className="text-white/85 text-base leading-relaxed">{c.goal}</p>
            </div>

            {/* Prezzo del singolo corso */}
            <div className="mt-8 pt-8 border-t border-white/10">
              <div className="flex items-end justify-between gap-4 flex-wrap">
                <div>
                  <div className="font-mono-label text-white/40 text-[11px] mb-2">Investimento oggi</div>
                  <div className="flex items-baseline gap-3">
                    <span className="font-display text-5xl lg:text-6xl text-white leading-none">€{c.price}</span>
                    <span className="text-white/40 text-lg line-through decoration-white/30">€{c.originalPrice}</span>
                  </div>
                  <div className="text-white/50 text-xs mt-2">iva esclusa • 3 rate senza interessi con PayPal</div>
                </div>
                <div className="text-right">
                  <div className="inline-flex items-center gap-2 border border-white/10 rounded-full px-3 py-1.5 text-white/70 text-[11px] uppercase tracking-widest">
                    <span className="w-1.5 h-1.5 rounded-full" style={{ background: "#3b5bff" }} />
                    Early Bird
                  </div>
                </div>
              </div>
            </div>

            <a href="#prezzo" className="btn-primary mt-8">
              Iscriviti al corso <ArrowUpRight size={16} />
            </a>
            <Link to={courseUrl(c.slug)} className="btn-secondary mt-3 inline-flex">
              Scopri il corso in dettaglio
            </Link>
          </div>

          <div className="lg:col-span-7 bg-card-2 border border-white/10 rounded-2xl p-8 lg:p-10">
            <div className="font-mono-label text-white/40 text-xs mb-6">Moduli del corso</div>
            <ul className="space-y-3">
              {c.modules.map((m, i) => (
                <li key={i} className="flex items-start gap-4 border-b border-white/5 pb-4 last:border-0">
                  <span className="font-mono-label text-white/30 text-xs mt-1">0{i + 1}</span>
                  <div className="flex items-start gap-3">
                    <CheckCircle2 size={18} className="text-lime flex-shrink-0 mt-0.5" style={{ color: "#d4ff3d" }} />
                    <span className="text-white/90 text-base lg:text-lg">{m}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
